<template>
  <div>
    <h6 v-if="profileId == 0" class="heading-small text-muted mb-4">
      Add New Brand Category {{ inputName ? " - " + this.inputName : "" }}
    </h6>
    <h6
      v-else-if="profileId != 0 && this.$attrs.viewMode == true"
      class="heading-small text-muted mb-4"
    >
      View Brand Category - {{ this.inputName }}
    </h6>
    <h6 v-else class="heading-small text-muted mb-4">
      Edit Brand Category - {{ this.inputName }}
    </h6>

    <base-alert v-if="errors.length" type="danger">
      <b>You have the following error(s):</b>
      <li v-for="error in errors" :key="error">{{ error }}</li>
    </base-alert>

    <b-tabs
      v-show="profileId != 0 && this.$attrs.viewMode == true"
      content-class="mt-3"
    >
      <b-tab title="Details" active v-on:click="openDetails"></b-tab>
      <b-tab title="History" v-on:click="openHistory">
        <b><label>Created By: </label></b>
        {{ brand_category.created_by || "System"  }} | {{ brand_category.created_at | dateFilter }}
        <br />
        <b><label>Updated By:</label></b>
        {{ brand_category.updated_by || "System"  }} | {{ brand_category.updated_at | dateFilter }}
      </b-tab>
    </b-tabs>

    <form id="form-proper">
      <!-- {{brand_category}} -->
      <div v-if="customFormMode == 1" v-show="showDetails">
        <!-- Normal -->
        <base-input
          alternative=""
          label="Code"
          placeholder=""
          v-model="brand_category.code"
          input-classes="form-control"
        />
        <base-input
          alternative=""
          label="Name"
          placeholder=""
          v-model="brand_category.name"
          input-classes="form-control"
          required
        />

        <base-input alternative="" label="Remark">
          <textarea rows="4" class="form-control" v-model="brand_category.remark" />
        </base-input>
      </div>
      <div v-if="customFormMode == 2">
        <!-- Override -->
        <dynamic-form
          :convertedJson="{ mode: customForm.mode, groups: customForm.groups }"
          :formSettings="brand_category"
          @valueUpdated="updateSettings"
          :key="dynamicFormKey"
        />
      </div>
      <div v-if="customFormMode == 3">
        <!-- Append -->
        <a-tabs defaultActiveKey="1">
          <a-tab-pane tab="Basic" key="1">
            <base-input
              alternative=""
              label="Code"
              placeholder=""
              v-model="brand_category.code"
              input-classes="form-control"
            />
            <base-input
              alternative=""
              label="Name"
              placeholder=""
              v-model="brand_category.name"
              input-classes="form-control"
              required
            />

            <base-input alternative="" label="Remark">
              <textarea rows="4" class="form-control" v-model="brand_category.remark" />
            </base-input>
          </a-tab-pane>
          <a-tab-pane tab="Custom Fields" key="2" forceRender>
            <dynamic-form
              :convertedJson="{
                mode: customForm.mode,
                groups: customForm.groups_append,
              }"
              :formSettings="brand_category"
              @valueUpdated="updateSettings"
              :key="dynamicFormKey"
              :showErrors="false"
            />
          </a-tab-pane>
        </a-tabs>
      </div>

      <div v-if="this.$attrs.viewMode != true">
        <div
          v-if="serverType == 'ho'"
          style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;"
        >
          <button
            v-if="profileId == 0"
            type="button"
            class="btn btn-primary float-right"
            @click.prevent="create"
          >
            Create
          </button>
          <button
            v-else
            type="button"
            class="btn btn-primary float-right"
            @click.prevent="update"
          >
            Update
          </button>
        </div>
        <div
          v-else
          style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;"
        >
          <button
            type="button"
            class="btn btn-primary float-right"
            @click.prevent="$emit('closeDrawer', null)"
          >
            Close
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import HTTPRequest from "../../controllers/httpRequest.js";
import ValidateField from "../../components/validateFormUtils.js";
import DynamicForm from "../DynamicForm.vue";
import { mapState } from "vuex";
import moment from "moment";
var component_x;
export default {
  components: {
    DynamicForm,
  },
  computed: {
    ...mapState(["endPoint", "profileId", "serverType"]),
  },
  mounted: async function() {
    const sytemModule = await HTTPRequest.getRequest(
      this.endPoint + "system_modules/Brand Category?field_name=name",
      null
    );
    const sytemModuleId = sytemModule.id;
    const accSystemModuleRequest = await HTTPRequest.getRequest(
      this.endPoint +
        "account_system_modules/" +
        sytemModuleId +
        "?field_name=system_module_id",
      null
    );
    if (this.isJsonString(accSystemModuleRequest.meta) == true) {
      const accSystemModule = JSON.parse(accSystemModuleRequest.meta);
      if (accSystemModule != null) {
        if (accSystemModule.form_mode != undefined) {
          this.customFormMode = accSystemModule.form_mode;
        }
        if (accSystemModule.customized_forms != undefined) {
          this.customForm = accSystemModule.customized_forms;
        }
      }
    }

    if (this.serverType == "branch" || this.$attrs.viewMode == true) {
      var form = document.getElementById("form-proper");
      var elements = form.elements;
      for (var i = 0, len = elements.length; i < len; ++i) {
        elements[i].readOnly = true;
      }
    }
    component_x = this;
    if (component_x.profileId > 0) {
      var brand_category_data = await HTTPRequest.getRequest(
        component_x.endPoint + "brand_categories/" + component_x.profileId,
        null
      );
      if (brand_category_data == undefined) {
        component_x.$router.go();
      } else {
        if (brand_category_data["error"] == undefined) {
          component_x.brand_category = brand_category_data;
          component_x.inputName = brand_category_data["name"];
          component_x.inputCode = brand_category_data["code"];
          component_x.inputRemark = brand_category_data["remark"];
        } else {
          this.errors = brand_category_data["error"].split(",");
        }
      }
    }

    this.dynamicFormKey++;
  },
  data: function() {
    return {
      inputName: "",
      inputCode: "",
      inputRemark: "",
      errors: [],
      showDetails: true,

      customFormMode: 1,
      customForm: {},
      profileData: {},
      dynamicFormKey: 0,
      brand_category: {},
      formErrors: [],
    };
  },
  filters: {
    dateFilter: function(timestamp) {
      return moment(timestamp).format("L LTS");
    },
  },
  methods: {
    updateSettings(newFormSettings, settingsGrouping, errors) {
      var formSettingsCopy = this.bagger;
      var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
      this.formErrors = errors;
      if (this.customFormMode == 3) {
        this.errors = errors;
      }
      this.bagger = mergedHash;
    },
    isJsonString(str) {
      try {
        var json = JSON.parse(str);
        return typeof json === "object";
      } catch (e) {
        return false;
      }
    },
    openDetails() {
      this.showDetails = true;
    },
    openHistory() {
      this.showDetails = false;
    },
    validateForm() {
      this.errors = [];
      // this.errors.push(ValidateField.required('Code', this.inputCode));
      // this.errors.push(ValidateField.alphanumericWithSpecialChars('Code', this.brand_category.code));
      this.errors.push(
        ValidateField.charMinAndMax("Code", this.brand_category.code, 0, 30)
      );

      this.errors.push(ValidateField.required("Name", this.brand_category.name));
      // this.errors.push(ValidateField.alphanumericWithSpecialChars('Name', this.brand_category.name));
      this.errors.push(
        ValidateField.charMinAndMax("Name", this.brand_category.name, 0, 50)
      );
      this.errors = this._.compact(this.errors);
      document.getElementsByClassName(
        "ant-drawer-wrapper-body"
      )[0].scrollTop = 0;
      return this.errors.length;
    },
    create: async function() {
      if (!this.validateForm()) {
        // var brand_categoryPayload = {
        //     brand_category: {
        //         name: this.inputName.trim(),
        //         code: this.inputCode.trim(),
        //         remark: this.inputRemark,
        //         status: 'A'
        //     }
        // }

        this.brand_category.name = this.brand_category.name.trim();
        if (this.brand_category.code != undefined)
          this.brand_category.code = this.brand_category.code.trim();
        this.brand_category.status = "A";
        var brand_categoryPayload = { brand_category: this.brand_category };

        var post_request = await HTTPRequest.postRequest(
          this.endPoint + "brand_categories",
          null,
          brand_categoryPayload
        );
        if (post_request == undefined) {
          this.$emit("refreshPage", event);
        } else {
          if (post_request["error"] == undefined) {
            this.$emit("refreshPage", event);
          } else {
            this.errors = post_request["error"].split(",");
          }
        }
      }
    },
    update: async function() {
      if (!this.validateForm()) {
        // var brand_categoryPayload = {
        //     brand_category: {
        //         name: this.inputName.trim(),
        //         code: this.inputCode.trim(),
        //         remark: this.inputRemark,
        //         status: 'A'
        //     }
        // }

        this.brand_category.name = this.brand_category.name.trim();
        if (this.brand_category.code != undefined)
          this.brand_category.code = this.brand_category.code.trim();

        // this.brand_category.status = 'A'
        let status = this.brand_category.status == null ? "A" : this.brand_category.status;
        this.brand_category.status = status;
        var brand_categoryPayload = { brand_category: this.brand_category };

        var put_request = await HTTPRequest.putRequest(
          this.endPoint + "brand_categories/" + this.profileId,
          null,
          brand_categoryPayload
        );
        if (put_request == undefined) {
          this.$emit("refreshPage", event);
        } else {
          if (put_request["error"] == undefined) {
            this.$emit("refreshPage", event);
          } else {
            this.errors = put_request["error"].split(",");
          }
        }
      }
    },
  },
};
</script>

<style></style>
